import React from "react";

export const APP_SCREENSHOTS = {
  onboarding: "/images/screens/app/onboarding.png",
  dashboard: "/images/screens/app/dashboard.png",
  groceryList: "/images/screens/app/grocery-list.png",
  recipeSteps: "/images/screens/app/recipe-steps.png",
  recipeDetail: "/images/screens/app/recipe-detail.png",
};

/**
 * PhoneFrame – wraps a screenshot in a subtle dark device-style frame.
 * Use aspect-[9/19.5] container by default; pass className to override.
 */
const PhoneFrame = ({ src, alt = "Mise at Home screenshot", className = "", testId }) => (
  <div
    className={`relative rounded-[2.25rem] border border-[#444444] bg-[#1a1a1a] p-2 shadow-[0_30px_60px_-20px_rgba(0,0,0,0.6)] ${className}`}
    data-testid={testId}
  >
    <div className="absolute top-3 left-1/2 -translate-x-1/2 h-1.5 w-20 rounded-full bg-[#0a0a0a] z-10" aria-hidden />
    <div className="overflow-hidden rounded-[1.85rem] bg-[#f6f4ef]">
      <img
        src={src}
        alt={alt}
        loading="lazy"
        className="block w-full h-auto select-none"
        draggable={false}
      />
    </div>
  </div>
);

export default PhoneFrame;
